module.exports = __webpack_public_path__ + "static/media/JakePrintButton.43f7dae9.png";